import React from 'react';
import useUserManager from '@ers/authorization/userManager';
import Types from './MenuItemTypes';
import Menus from './Menus';
import { Typo } from '../ui';

const LogoutMenuItem = {
    type: Types.Logout,
    url: () => '',
    name: 'Wyloguj',
    icon: 'logout',
    simpleLayout: false,
    onClick: () => {
        const userManager = useUserManager();
        userManager.signoutRedirect();
        return false;
    },

    nameRender: (name) => <Typo.Body>{name}</Typo.Body>,
    place: Menus.UserBox
};

export default LogoutMenuItem;